"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _abbadiaCerreto = _interopRequireDefault(require("./17_group_2023_01_31/abbadia-cerreto"));

var _acquasparta = _interopRequireDefault(require("./17_group_2023_01_31/acquasparta"));

var _aggius = _interopRequireDefault(require("./17_group_2023_01_31/aggius"));

var _agrigento = _interopRequireDefault(require("./17_group_2023_01_31/agrigento"));

var _albizzate = _interopRequireDefault(require("./17_group_2023_01_31/albizzate"));

var _altissimo = _interopRequireDefault(require("./17_group_2023_01_31/altissimo"));

var _ancona = _interopRequireDefault(require("./17_group_2023_01_31/ancona"));

var _antignano = _interopRequireDefault(require("./17_group_2023_01_31/antignano"));

var _argusto = _interopRequireDefault(require("./17_group_2023_01_31/argusto"));

var _atenaLucana = _interopRequireDefault(require("./17_group_2023_01_31/atena-lucana"));

var _baceno = _interopRequireDefault(require("./17_group_2023_01_31/baceno"));

var _badesi = _interopRequireDefault(require("./17_group_2023_01_31/badesi"));

var _belmonteDelSannio = _interopRequireDefault(require("./17_group_2023_01_31/belmonte-del-sannio"));

var _benevento = _interopRequireDefault(require("./17_group_2023_01_31/benevento"));

var _bianchi = _interopRequireDefault(require("./17_group_2023_01_31/bianchi"));

var _borgoPriolo = _interopRequireDefault(require("./17_group_2023_01_31/borgo-priolo"));

var _bortigiadas = _interopRequireDefault(require("./17_group_2023_01_31/bortigiadas"));

var _brezzoDiBedero = _interopRequireDefault(require("./17_group_2023_01_31/brezzo-di-bedero"));

var _budoia = _interopRequireDefault(require("./17_group_2023_01_31/budoia"));

var _buttrio = _interopRequireDefault(require("./17_group_2023_01_31/buttrio"));

var _calosso = _interopRequireDefault(require("./17_group_2023_01_31/calosso"));

var _caltanissetta = _interopRequireDefault(require("./17_group_2023_01_31/caltanissetta"));

var _capergnanica = _interopRequireDefault(require("./17_group_2023_01_31/capergnanica"));

var _carcare = _interopRequireDefault(require("./17_group_2023_01_31/carcare"));

var _carrara = _interopRequireDefault(require("./17_group_2023_01_31/carrara"));

var _carro = _interopRequireDefault(require("./17_group_2023_01_31/carro"));

var _casaleCorteCerro = _interopRequireDefault(require("./17_group_2023_01_31/casale-corte-cerro"));

var _casaleLitta = _interopRequireDefault(require("./17_group_2023_01_31/casale-litta"));

var _casamarciano = _interopRequireDefault(require("./17_group_2023_01_31/casamarciano"));

var _caserta = _interopRequireDefault(require("./17_group_2023_01_31/caserta"));

var _casperia = _interopRequireDefault(require("./17_group_2023_01_31/casperia"));

var _castelfrancoEmilia = _interopRequireDefault(require("./17_group_2023_01_31/castelfranco-emilia"));

var _castelgerundo = _interopRequireDefault(require("./17_group_2023_01_31/castelgerundo"));

var _castellanaSicula = _interopRequireDefault(require("./17_group_2023_01_31/castellana-sicula"));

var _castellettoMerli = _interopRequireDefault(require("./17_group_2023_01_31/castelletto-merli"));

var _castelraimondo = _interopRequireDefault(require("./17_group_2023_01_31/castelraimondo"));

var _ceraso = _interopRequireDefault(require("./17_group_2023_01_31/ceraso"));

var _cerrinaMonferrato = _interopRequireDefault(require("./17_group_2023_01_31/cerrina-monferrato"));

var _cesenatico = _interopRequireDefault(require("./17_group_2023_01_31/cesenatico"));

var _chieti = _interopRequireDefault(require("./17_group_2023_01_31/chieti"));

var _civitaDAntino = _interopRequireDefault(require("./17_group_2023_01_31/civita-d-antino"));

var _civitellaCasanova = _interopRequireDefault(require("./17_group_2023_01_31/civitella-casanova"));

var _colleBrianza = _interopRequireDefault(require("./17_group_2023_01_31/colle-brianza"));

var _colognaVeneta = _interopRequireDefault(require("./17_group_2023_01_31/cologna-veneta"));

var _comazzo = _interopRequireDefault(require("./17_group_2023_01_31/comazzo"));

var _corteBrugnatella = _interopRequireDefault(require("./17_group_2023_01_31/corte-brugnatella"));

var _donato = _interopRequireDefault(require("./17_group_2023_01_31/donato"));

var _enego = _interopRequireDefault(require("./17_group_2023_01_31/enego"));

var _enna = _interopRequireDefault(require("./17_group_2023_01_31/enna"));

var _fiumedinisi = _interopRequireDefault(require("./17_group_2023_01_31/fiumedinisi"));

var _flumeri = _interopRequireDefault(require("./17_group_2023_01_31/flumeri"));

var _foggia = _interopRequireDefault(require("./17_group_2023_01_31/foggia"));

var _formazza = _interopRequireDefault(require("./17_group_2023_01_31/formazza"));

var _frassilongo = _interopRequireDefault(require("./17_group_2023_01_31/frassilongo"));

var _garlenda = _interopRequireDefault(require("./17_group_2023_01_31/garlenda"));

var _garnigaTerme = _interopRequireDefault(require("./17_group_2023_01_31/garniga-terme"));

var _gazzo = _interopRequireDefault(require("./17_group_2023_01_31/gazzo"));

var _genzanoDiRoma = _interopRequireDefault(require("./17_group_2023_01_31/genzano-di-roma"));

var _giustenice = _interopRequireDefault(require("./17_group_2023_01_31/giustenice"));

var _golfoAranci = _interopRequireDefault(require("./17_group_2023_01_31/golfo-aranci"));

var _greveInChianti = _interopRequireDefault(require("./17_group_2023_01_31/greve-in-chianti"));

var _guiglia = _interopRequireDefault(require("./17_group_2023_01_31/guiglia"));

var _imola = _interopRequireDefault(require("./17_group_2023_01_31/imola"));

var _isernia = _interopRequireDefault(require("./17_group_2023_01_31/isernia"));

var _liberi = _interopRequireDefault(require("./17_group_2023_01_31/liberi"));

var _limbiate = _interopRequireDefault(require("./17_group_2023_01_31/limbiate"));

var _loreo = _interopRequireDefault(require("./17_group_2023_01_31/loreo"));

var _macerataFeltria = _interopRequireDefault(require("./17_group_2023_01_31/macerata-feltria"));

var _madonnaDelSasso = _interopRequireDefault(require("./17_group_2023_01_31/madonna-del-sasso"));

var _malfa = _interopRequireDefault(require("./17_group_2023_01_31/malfa"));

var _manoppello = _interopRequireDefault(require("./17_group_2023_01_31/manoppello"));

var _marcignago = _interopRequireDefault(require("./17_group_2023_01_31/marcignago"));

var _mazzin = _interopRequireDefault(require("./17_group_2023_01_31/mazzin"));

var _meldola = _interopRequireDefault(require("./17_group_2023_01_31/meldola"));

var _mesoraca = _interopRequireDefault(require("./17_group_2023_01_31/mesoraca"));

var _milena = _interopRequireDefault(require("./17_group_2023_01_31/milena"));

var _modena = _interopRequireDefault(require("./17_group_2023_01_31/modena"));

var _montecastrilli = _interopRequireDefault(require("./17_group_2023_01_31/montecastrilli"));

var _nocciano = _interopRequireDefault(require("./17_group_2023_01_31/nocciano"));

var _nuoro = _interopRequireDefault(require("./17_group_2023_01_31/nuoro"));

var _oggebbio = _interopRequireDefault(require("./17_group_2023_01_31/oggebbio"));

var _ogliastroCilento = _interopRequireDefault(require("./17_group_2023_01_31/ogliastro-cilento"));

var _ostraVetere = _interopRequireDefault(require("./17_group_2023_01_31/ostra-vetere"));

var _perdaxius = _interopRequireDefault(require("./17_group_2023_01_31/perdaxius"));

var _pesaro = _interopRequireDefault(require("./17_group_2023_01_31/pesaro"));

var _pescia = _interopRequireDefault(require("./17_group_2023_01_31/pescia"));

var _piedimulera = _interopRequireDefault(require("./17_group_2023_01_31/piedimulera"));

var _pieveSantoStefano = _interopRequireDefault(require("./17_group_2023_01_31/pieve-santo-stefano"));

var _pieveTorina = _interopRequireDefault(require("./17_group_2023_01_31/pieve-torina"));

var _pinzanoAlTagliamento = _interopRequireDefault(require("./17_group_2023_01_31/pinzano-al-tagliamento"));

var _piombino = _interopRequireDefault(require("./17_group_2023_01_31/piombino"));

var _pistoia = _interopRequireDefault(require("./17_group_2023_01_31/pistoia"));

var _polia = _interopRequireDefault(require("./17_group_2023_01_31/polia"));

var _pomezia = _interopRequireDefault(require("./17_group_2023_01_31/pomezia"));

var _pordenone = _interopRequireDefault(require("./17_group_2023_01_31/pordenone"));

var _portacomaro = _interopRequireDefault(require("./17_group_2023_01_31/portacomaro"));

var _pray = _interopRequireDefault(require("./17_group_2023_01_31/pray"));

var _roverbella = _interopRequireDefault(require("./17_group_2023_01_31/roverbella"));

var _sanGenesioAtesino = _interopRequireDefault(require("./17_group_2023_01_31/san-genesio-atesino"));

var _sanLeucioDelSannio = _interopRequireDefault(require("./17_group_2023_01_31/san-leucio-del-sannio"));

var _sanMangoSulCalore = _interopRequireDefault(require("./17_group_2023_01_31/san-mango-sul-calore"));

var _sanMiniato = _interopRequireDefault(require("./17_group_2023_01_31/san-miniato"));

var _sanSostene = _interopRequireDefault(require("./17_group_2023_01_31/san-sostene"));

var _santOmero = _interopRequireDefault(require("./17_group_2023_01_31/sant-omero"));

var _santaMargheritaDiStaffora = _interopRequireDefault(require("./17_group_2023_01_31/santa-margherita-di-staffora"));

var _santoStefanoDAveto = _interopRequireDefault(require("./17_group_2023_01_31/santo-stefano-d-aveto"));

var _sassocorvaroAuditore = _interopRequireDefault(require("./17_group_2023_01_31/sassocorvaro-auditore"));

var _senigallia = _interopRequireDefault(require("./17_group_2023_01_31/senigallia"));

var _sestoFiorentino = _interopRequireDefault(require("./17_group_2023_01_31/sesto-fiorentino"));

var _siena = _interopRequireDefault(require("./17_group_2023_01_31/siena"));

var _taormina = _interopRequireDefault(require("./17_group_2023_01_31/taormina"));

var _taranto = _interopRequireDefault(require("./17_group_2023_01_31/taranto"));

var _teramo = _interopRequireDefault(require("./17_group_2023_01_31/teramo"));

var _terni = _interopRequireDefault(require("./17_group_2023_01_31/terni"));

var _tiriolo = _interopRequireDefault(require("./17_group_2023_01_31/tiriolo"));

var _tirolo = _interopRequireDefault(require("./17_group_2023_01_31/tirolo"));

var _toraEPiccilli = _interopRequireDefault(require("./17_group_2023_01_31/tora-e-piccilli"));

var _tornolo = _interopRequireDefault(require("./17_group_2023_01_31/tornolo"));

var _torreDePicenardi = _interopRequireDefault(require("./17_group_2023_01_31/torre-de-picenardi"));

var _torregrotta = _interopRequireDefault(require("./17_group_2023_01_31/torregrotta"));

var _tramonti = _interopRequireDefault(require("./17_group_2023_01_31/tramonti"));

var _trevico = _interopRequireDefault(require("./17_group_2023_01_31/trevico"));

var _trieste = _interopRequireDefault(require("./17_group_2023_01_31/trieste"));

var _urbino = _interopRequireDefault(require("./17_group_2023_01_31/urbino"));

var _valbrona = _interopRequireDefault(require("./17_group_2023_01_31/valbrona"));

var _valdaone = _interopRequireDefault(require("./17_group_2023_01_31/valdaone"));

var _valleCannobina = _interopRequireDefault(require("./17_group_2023_01_31/valle-cannobina"));

var _valleDiCasies = _interopRequireDefault(require("./17_group_2023_01_31/valle-di-casies"));

var _valmorea = _interopRequireDefault(require("./17_group_2023_01_31/valmorea"));

var _venegonoInferiore = _interopRequireDefault(require("./17_group_2023_01_31/venegono-inferiore"));

var _vignaleMonferrato = _interopRequireDefault(require("./17_group_2023_01_31/vignale-monferrato"));

var _vizzolaTicino = _interopRequireDefault(require("./17_group_2023_01_31/vizzola-ticino"));

var _vogogna = _interopRequireDefault(require("./17_group_2023_01_31/vogogna"));

var _zenevredo = _interopRequireDefault(require("./17_group_2023_01_31/zenevredo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _abbadiaCerreto["default"], {}, _acquasparta["default"], {}, _aggius["default"], {}, _agrigento["default"], {}, _albizzate["default"], {}, _altissimo["default"], {}, _ancona["default"], {}, _antignano["default"], {}, _argusto["default"], {}, _atenaLucana["default"], {}, _baceno["default"], {}, _badesi["default"], {}, _belmonteDelSannio["default"], {}, _benevento["default"], {}, _bianchi["default"], {}, _borgoPriolo["default"], {}, _bortigiadas["default"], {}, _brezzoDiBedero["default"], {}, _budoia["default"], {}, _buttrio["default"], {}, _calosso["default"], {}, _caltanissetta["default"], {}, _capergnanica["default"], {}, _carcare["default"], {}, _carrara["default"], {}, _carro["default"], {}, _casaleCorteCerro["default"], {}, _casaleLitta["default"], {}, _casamarciano["default"], {}, _caserta["default"], {}, _casperia["default"], {}, _castelfrancoEmilia["default"], {}, _castelgerundo["default"], {}, _castellanaSicula["default"], {}, _castellettoMerli["default"], {}, _castelraimondo["default"], {}, _ceraso["default"], {}, _cerrinaMonferrato["default"], {}, _cesenatico["default"], {}, _chieti["default"], {}, _civitaDAntino["default"], {}, _civitellaCasanova["default"], {}, _colleBrianza["default"], {}, _colognaVeneta["default"], {}, _comazzo["default"], {}, _corteBrugnatella["default"], {}, _donato["default"], {}, _enego["default"], {}, _enna["default"], {}, _fiumedinisi["default"], {}, _flumeri["default"], {}, _foggia["default"], {}, _formazza["default"], {}, _frassilongo["default"], {}, _garlenda["default"], {}, _garnigaTerme["default"], {}, _gazzo["default"], {}, _genzanoDiRoma["default"], {}, _giustenice["default"], {}, _golfoAranci["default"], {}, _greveInChianti["default"], {}, _guiglia["default"], {}, _imola["default"], {}, _isernia["default"], {}, _liberi["default"], {}, _limbiate["default"], {}, _loreo["default"], {}, _macerataFeltria["default"], {}, _madonnaDelSasso["default"], {}, _malfa["default"], {}, _manoppello["default"], {}, _marcignago["default"], {}, _mazzin["default"], {}, _meldola["default"], {}, _mesoraca["default"], {}, _milena["default"], {}, _modena["default"], {}, _montecastrilli["default"], {}, _nocciano["default"], {}, _nuoro["default"], {}, _oggebbio["default"], {}, _ogliastroCilento["default"], {}, _ostraVetere["default"], {}, _perdaxius["default"], {}, _pesaro["default"], {}, _pescia["default"], {}, _piedimulera["default"], {}, _pieveSantoStefano["default"], {}, _pieveTorina["default"], {}, _pinzanoAlTagliamento["default"], {}, _piombino["default"], {}, _pistoia["default"], {}, _polia["default"], {}, _pomezia["default"], {}, _pordenone["default"], {}, _portacomaro["default"], {}, _pray["default"], {}, _roverbella["default"], {}, _sanGenesioAtesino["default"], {}, _sanLeucioDelSannio["default"], {}, _sanMangoSulCalore["default"], {}, _sanMiniato["default"], {}, _sanSostene["default"], {}, _santOmero["default"], {}, _santaMargheritaDiStaffora["default"], {}, _santoStefanoDAveto["default"], {}, _sassocorvaroAuditore["default"], {}, _senigallia["default"], {}, _sestoFiorentino["default"], {}, _siena["default"], {}, _taormina["default"], {}, _taranto["default"], {}, _teramo["default"], {}, _terni["default"], {}, _tiriolo["default"], {}, _tirolo["default"], {}, _toraEPiccilli["default"], {}, _tornolo["default"], {}, _torreDePicenardi["default"], {}, _torregrotta["default"], {}, _tramonti["default"], {}, _trevico["default"], {}, _trieste["default"], {}, _urbino["default"], {}, _valbrona["default"], {}, _valdaone["default"], {}, _valleCannobina["default"], {}, _valleDiCasies["default"], {}, _valmorea["default"], {}, _venegonoInferiore["default"], {}, _vignaleMonferrato["default"], {}, _vizzolaTicino["default"], {}, _vogogna["default"], {}, _zenevredo["default"]);

exports["default"] = _default;